module.exports = __webpack_public_path__ + "static/media/madurez_a_otro_nivel.803aca6e.jpg";